const e={WithinQueryParameters:0,WithinHeaders:1};export{e as AuthMode};
